exports.resourceLinks = [
    {
        title: 'General References',
        resources: [
            {
                name: 'Riichi Mahjong Primer Brochure',
                desc: 'A guide prepared by Kansas City Riichi Mahjong to serve as a concise generalized "how-to-play" that can be handed to new players. Designed to be printed out, the majority of the information was taken from mahjong.guide and tweaked to fit on a single page brochure.',
                href: 'https://docs.google.com/document/d/1nx8XIndgciChgdwnB_x3owM34EuMkZ7vpGM_rqsEqU8/edit?usp=sharing'
            },
            {
                name: "Mahjong Guide: Beginner's Guide to Riichi Mahjong",
                desc: '',
                href: 'https://mahjong.guide/a-beginners-guide-to-riichi-mahjong/'
            },
            {
                name: 'Riichi Mahjong Wiki',
                desc: '',
                href: 'https://riichi.wiki/Main_Page'
            },
            {
                name: 'World Riichi Championship Rules',
                desc: '',
                href: 'https://www.worldriichi.org/wrc-rules'
            },
            {
                name: 'An Exhaustive List of Terminolog',
                desc: '',
                href: 'https://mahjong-ny.com/features/terminology/'
            }
        ]
    },
    {
        title: 'Intermediate - Advanced Resources',
        resources: [
            {
                name: '"Riichi Book 1" A book written by Daina Chiba.',
                desc: 'Covers basic concepts like tile efficiency, five block theory, defense, etc. A popular read for many.',
                href: 'https://dainachiba.github.io/RiichiBooks/'
            },
            {
                name: "Daina Chiba's Seminar - PDF",
                desc: '2017 WWYD (What Would You Do) Quizzes over basic concepts addressed in Riichi Book 1.',
                href: 'https://files.riichi.moe/mjg/books%20(en)/Riichi%20Seminar%202017.pdf '
            },
            {
                name: "Daina Chiba's Seminar - YouTube",
                desc: '2017 WWYD (What Would You Do) Quizzes over basic concepts addressed in Riichi Book 1.',
                href: 'https://www.youtube.com/watch?v=IrurdaLsBMY&list=PL6uk5miE0Y-Cwjhk7fYdqlm8jOrNXiLQ-'
            },
            {
                name: '2018 Five Block Method/Calling Judgements',
                desc: '',
                href: 'https://files.riichi.moe/mjg/books%20(en)/Riichi%20Seminar%202018.pdf'
            },
            {
                name: 'Excerpts from Super Digital Mahjong by Kobayashi Gō',
                desc: 'Translated Excerpts from Super Digital Mahjong going over many intermediate to advanced strategies.',
                href: 'https://natsuai.com/mahjong/digital/'
            },
            {
                name: '"Riichi Mahjong Strategy"',
                desc: 'A strategy book from Japan authored by Nemata & Makoto Fukuchi and translated by an anonymous Samaritan.',
                href: 'https://files.riichi.moe/mjg/books%20(en)/Riichi%20Mahjong%20Strategy%20(rms).pdf'
            },
            {
                name: '"Statistical Mahjong Strategy"',
                desc: 'An analysis of tons of tenhou games and their statistical outcomes. Written by Miinin, translated by an anon Samaritan.',
                href: 'https://files.riichi.moe/mjg/books%20(en)/Statistical%20Mahjong%20Strategy%20(sms).pdf'
            },
            {
                name: 'Mahjong Guide: Collection of Intermediate-Advanced Mahjong Strategy Articles',
                desc: '',
                href: 'https://mahjong.guide/list-of-articles/'
            },
            {
                name: '"100 Latest Techniques of Strong Players"',
                desc: "A translation of a series 100 WWYD (What Would You Do) Scenarios with answers from pro-players on the internet Riichi Mahjong Community, followed by the author's thoughts. Written by Higa Hidehito.",
                href: 'https://files.riichi.moe/mjg/books%20(en)/100%20Latest%20Techniques%20of%20Strong%20Players%20-%20Hidehito%20Higa.pdf'
            }
        ]
    },
    {
        title: 'Calculator / Tool / Trainers',
        resources: [
            {
                name: 'Tile Efficiency Trainer',
                desc: '',
                href: 'https://euophrys.itch.io/mahjong-efficiency-trainer'
            },
            {
                name: 'Riichi Score Trainer',
                desc: 'Train your expertise of not needing the infamous Riichi Score Chart.',
                href: 'https://mahjong.horneds.com/'
            },
            {
                name: 'Tile Efficiency AI Reviewing Your Mahjong Soul / Tenhou Game',
                desc: 'Grab your Mahjong Soul or Tenhou Log Link and have this AI analyze your game for tile efficiency. Treat this as a tool, not the bible of Riichi Mahjong. The AI does not compare to pro players.',
                href: 'https://mjai.ekyu.moe/'
            },
            {
                name: 'Mahjong Soul Stats',
                desc: 'Log of high ranked games, various stats, winning yaku stats, etc.',
                href: 'https://amae-koromo.sapk.ch/statistics/fan-stats'
            }
        ]
    }
];